import React from 'react';
import { Card, CardProps } from '@mui/material';

interface GlassCardProps extends CardProps {
  blur?: number;
}

export const GlassCard: React.FC<GlassCardProps> = ({ children, blur = 20, sx, ...props }) => {
  return (
    <Card
      {...props}
      sx={{
        background: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: `blur(${blur}px)`,
        WebkitBackdropFilter: `blur(${blur}px)`,
        border: '1px solid rgba(255, 255, 255, 0.5)',
        borderRadius: '20px',
        boxShadow: '0px 8px 32px rgba(99, 102, 241, 0.1)',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0px 12px 48px rgba(99, 102, 241, 0.2)',
          background: 'rgba(255, 255, 255, 0.8)',
        },
        ...sx,
      }}
    >
      {children}
    </Card>
  );
};
